import { UseContextApp } from "../Global/Context/appContext";
import ServerCall from "./ServerCall";

const DomiciliacionController = () => {
  const [{ user }] = UseContextApp();

   
 const domiciliacion = async (input) => {
    var body = new FormData();
      body.append("nombre", input.nombre); 
      body.append("tipoCliente", input.tipoCliente); 
      body.append("docIdentidad", input.docIdentidad); 
      body.append("email", input.email);
      body.append("tlfContacto", input.tlfContacto);
      body.append("ciudad", input.ciudad);
      body.append("cuenta", input.cuenta);
      body.append("tipoDomiciliacion", input.tipoDomiciliacion);
      body.append("bancoCta", input.bancoCta);
      body.append("bancoTDC", input.bancoTDC);
      body.append("titularBancario", input.titularBancario);
      body.append("docIdentidadTitularBancario", input.docIdentidadTitularBancario);
      body.append("nroCuentaDomiciliar", input.nroCuentaDomiciliar); 
      body.append("nroTarjeta", input.nroTarjeta); 
      body.append("fechaVencimiento", input.fechaVencimiento);
      body.append("tipoTarjeta", input.tipoTarjeta);
      body.append("cvv", input.cvv);
     const response = await ServerCall.postNetUno(
      `/Domiciliar`,
      body

    );
    return response;
};


  return {
    domiciliacion
  };
};

export default DomiciliacionController;
